import React from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import Yup from 'yup';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  submitted: PropTypes.bool.isRequired,
};

const DemoRequestForm = ({
  handleSubmit,
  isSubmitting,
  isValid,
  handleChange,
  handleBlur,
  submitted,
}) => {
  if (submitted) {
    return (
      <div className="alert alert-success" role="alert">
        Thanks for requesting a demo. We&apos;ll contact you shortly to schedule a call.
      </div>
    );
  }

  return (
    <form
      className="DemoRequestForm"
      noValidate
      onSubmit={handleSubmit}
    >
      <div className="form-row">
        <div className="form-group col-md-6">
          <label htmlFor="first_name" className="required">First Name</label>
          <input
            id="first_name"
            name="first_name"
            className="form-control"
            onChange={handleChange}
            onBlur={handleBlur}
            autoComplete="nope"
          />
        </div>

        <div className="form-group col-md-6">
          <label htmlFor="last_name" className="required">Last Name</label>
          <input
            id="last_name"
            name="last_name"
            className="form-control"
            onChange={handleChange}
            onBlur={handleBlur}
            autoComplete="nope"
          />
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="email" className="required">Email Address</label>
        <input
          type="email"
          id="email"
          name="email"
          className="form-control"
          onChange={handleChange}
          onBlur={handleBlur}
          autoComplete="nope"
        />
      </div>

      <div className="form-group">
        <label htmlFor="phone" className="required">Phone</label>
        <input
          type="phone"
          id="phone"
          name="phone"
          className="form-control"
          onChange={handleChange}
          onBlur={handleBlur}
          autoComplete="nope"
        />
      </div>

      <div className="form-group">
        <label htmlFor="company_name" className="required">Company Name</label>
        <input
          type="text"
          id="company_name"
          name="company_name"
          className="form-control"
          onChange={handleChange}
          onBlur={handleBlur}
          autoComplete="nope"
        />
      </div>

      <div className="form-group">
        <label htmlFor="referral_source">How&apos;d you hear about us?</label>
        <select
          type="text"
          id="referral_source"
          name="referral_source"
          className="form-control"
          onChange={handleChange}
          onBlur={handleBlur}
          autoComplete="nope"
        >
          <option value=""></option>
          <option value="email">Email</option>
          <option value="facebook">Facebook</option>
          <option value="friend">Friend</option>
          <option value="google_ad">Google Ad</option>
          <option value="google_search">Google Search</option>
          <option value="trade_show">Trade Show</option>
          <option value="other">Other</option>
        </select>
      </div>

      <button
        type="submit"
        className="btn btn-success"
        disabled={!isValid || isSubmitting}
      >
        Schedule a Demo!
      </button>
    </form>
  );
};

DemoRequestForm.propTypes = propTypes;

export default withFormik({
  validationSchema: Yup.object().shape({
    first_name: Yup.string().required(),
    last_name: Yup.string().required(),
    email: Yup.string().required(),
    phone: Yup.string().required(),
    company_name: Yup.string().required(),
    referral_source: Yup.string(),
  }),
  handleSubmit: (values, formikBag) => {
    const { setSubmitting, props: { onSubmit } } = formikBag;
    onSubmit(values, setSubmitting);
  },
})(DemoRequestForm);



// WEBPACK FOOTER //
// ./src/components/DemoRequestForm.js